<template>
    <div class="component">
        <vue-headful
                title="Add preview | W&S Docs"
        />
        <div v-if="loading" class="loading">
            <div class="spinner-border" role="status">
                <span class="sr-only">Loading...</span>
            </div>
        </div>

        <div v-if="result" class="alert alert-secondary text-success font-weight-bold" role="alert">
            Тема успешно добавлена!
        </div>

        <div class="form-group">
            <router-link class="btn bg-dark text-white" to="/admin/previews">Вернуться назад</router-link>
        </div>
        <div class="form-group">
            <label for="theme" class="">Выберите тему</label>
            <select id="theme" class="custom-select bg-dark text-white" v-model="theme">
                <option disabled>Выберите тему</option>
                <option v-for="(theme, index) in themes" :key="index" :value="theme.theme_id">{{theme.theme_title}}
                </option>
            </select>
        </div>
        <div class="form-group">
            <label for="title">Введите название</label>
            <input id="title" type="text" class="form-control bg-dark text-white" placeholder="Введите название"
                   v-model="title"/>
        </div>
        <div class="form-group">
            <label for="desc">Введите описание</label>
            <input id="desc" type="text" class="form-control bg-dark text-white" placeholder="Введите описание"
                   v-model="desc"/>
        </div>
        <div class="form-group">
            <label for="link">Введите краткий адрес</label>
            <input id="link" type="text" class="form-control bg-dark text-white" placeholder="Введите краткий адрес"
                   v-model="link"/>
            <small class="form-text text-muted">Например: user.get</small>
        </div>
        <div class="form-group">
            <VueTrix v-model="content" placeholder="Введите содержимое" id="text" localStorage/>
        </div>
        <button class="btn btn-dark" id="submit_btn" v-on:click="AddNewPreview">Добавить превью</button>
        <div class="method mt-4">
            Предпросмотр:
            <div class="container-fluid ">
                <h2>{{ title }}</h2>
                <p v-html="content">{{ content }}</p>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from "vue";
    import VueTrix from "vue-trix";
    import axios from "axios";

    Vue.use(VueTrix);
    export default {
        name: "PreviewAdd",
        components: {
            VueTrix,
        },
        data() {
            return {
                themes: [],
                theme: this.theme,
                title: this.title,
                content: this.content,
                link: this.link,
                desc: this.desc,
                result: null,
                loading: true,
            };
        },
        methods: {
            AddNewPreview: function () {
                let params = new URLSearchParams();
                params.append("preview_theme", this.theme);
                params.append("preview_title", this.title);
                params.append("preview_desc", this.desc);
                params.append("preview_content", this.content);
                params.append("preview_link", this.link);
                axios({
                    method: "post",
                    headers: {"Content-Type": "application/x-www-form-urlencoded"},
                    url: "https://api.write-and-share.ml/docs/preview.add",
                    data: params,
                })
                    .then(
                        this.theme = this.title = this.content = this.link = this.desc = "",
                        this.result = true
                    )
            },
        },
        mounted() {
            axios('https://api.write-and-share.ml/docs/theme.get')
                .then(response => {
                    this.themes = response.data.response
                });
            this.loading = false;
        },
    }
</script>

<style>
</style>
